import {
  takeEvery,
  call,
  put,
  select,
} from 'redux-saga/effects';
import _ from 'lodash';
import axios from '../axiosConfig';
import {
  getRoomDescriptionRequest,
  getRoomDetailRequest,
  getRoomDetailResponse,
  setCurrentRateDetailCode,
} from '../../slices/hotel';
import { getFullRawDescription } from '../../../components/TravelOption/HotelInformation/HotelDetails/RoomsDetails';
import { setProductsCodesAddedToBrochure, setProductsCodesAddingToBrochure } from '../../slices/brochure';
import { logErrorToConsole } from '../../../constants';
import { updateProductInSelectedTrip } from '../../slices/trip';

const queryString = require('query-string');

function* getHotelRoomDetailsWorker({
  payload: {
    hotelProducts,
    hotelProviderId,
    hotelKey,
    searchKey,
    doCallEnhanceDesc,
    doAddToBrochure,
    isAnyRateFromHotelAddedToTrip,
  },
}) {
  const product = hotelProducts?.at(0) ?? {};
  const { currencyCode } = yield select((store) => store.tripSearch);
  const currentCodes = yield select((store) => store.hotel?.productsCodesAddingToBrochure ?? []);
  if (doAddToBrochure) {
    yield put(setProductsCodesAddingToBrochure({ productCodes: [...currentCodes, product.code] }));
  }

  try {
    const qs = currencyCode ? queryString.stringify({ currencyCode, hotelId: hotelProviderId }) : '';
    const url = `/hotels/getHotelRoomDetails?${qs}`;
    const config = {
      method: 'post',
      url,
      data: JSON.stringify(_.map(hotelProducts, (p) => p.code)),
      headers: {
        'Content-Type': 'application/json',
      },
    };

    const { data } = yield call(axios, config);

    if (doAddToBrochure) {
      yield put(setProductsCodesAddingToBrochure({
        productCodes: currentCodes.filter((code) => code !== product.code),
      }));
    }

    const rawRate = (data && Object.values(data)[0]) || product;
    const rate = { ...rawRate, previousProductCode: product.code };
    yield put(getRoomDetailResponse({
      hotelKey, data, searchKey, existingProduct: product,
    }));

    if (isAnyRateFromHotelAddedToTrip) {
      yield put(updateProductInSelectedTrip({ hotelKey, product: rate }));
    }

    if (doAddToBrochure) yield put(setProductsCodesAddedToBrochure({ productCode: rate?.code }));

    if (!doAddToBrochure) {
      yield put(setCurrentRateDetailCode({ hotelKey, rateCode: rate.code }));
    }

    if (doCallEnhanceDesc && rate?.code) {
      yield put(getRoomDescriptionRequest({
        code: rate.code,
        description: getFullRawDescription(rate),
        currencyCode: rate.roomPrice?.propertyCurrencyCode || rate.roomPrice?.currencyCode,
      }));
    }
  } catch (error) {
    logErrorToConsole(`Error fetching hotel room details for product ${product}: `, error);
    yield put(getRoomDetailResponse({ hotelKey, searchKey, existingProduct: product }));
    if (doAddToBrochure) {
      yield put(setProductsCodesAddingToBrochure({
        productCodes: currentCodes.filter((code) => code !== product.code),
      }));
      yield put(setProductsCodesAddedToBrochure({ productCode: product?.code }));
    }
  }
}

function* getHotelRoomDetailsWatcher() {
  yield takeEvery(getRoomDetailRequest.toString(), getHotelRoomDetailsWorker);
}

export default getHotelRoomDetailsWatcher;
